import { useEffect, useState } from "react";
import {  useParams } from "react-router";
import './Invitacion.css';
import { getInvitados } from "../../fetch/invitados";
import Portada from "../info/Portada";
import Contador from "../contador/Contador";
import Presentacion from "../presentacion/Presentacion";
import Ubicacion from "../ubicacion/Ubicacion";
import Hotel from "../hoteles/Hoteles";
import Vestimenta from "../vestimenta/Vestimenta";
import Ch from '../../sources/icons/Church2.png'
import Wd from '../../sources/icons/Wedding.png'
import Ht from '../../sources/icons/hotel.png'
//import song from './sources/music/Fondo.mpeg'

export default function Invitacion() {

  let params = useParams();
  const [invitados, setInvitados] = useState([])
  useEffect(() => {
    if (params.hash) {
      getInvitados(params.hash).then(res => {
        //console.log(res)
        setInvitados(res)
      })
    }

  }, [params])

  return (

    <div className="Invitacion-Body">
      <Presentacion />
      <Portada inv={invitados} />
      <Contador DateHour='2026-11-28T14:00:00' />
 
      <Ubicacion
        title='Ceremonia Religiosa y Recepción'
        name='Finca JB'
        fecha='28/Nov/2026'
        hora='16:00 hrs'
        dir='Rancheria Guineo 1ra Seccion, 86283 Buena Vista Río Nuevo 1ra. Secc., Tab.'
        icon={Ch}
        center={{ lat: 17.91320403784439, lng: -93.02714312108884 }}
        markers={[
          { pos: { lat: 17.91320403784439, lng: -93.02714312108884 }, info: 'Recepción' }
        ]} />
      <Vestimenta name='sves' gen='Mujeres' desc='Vestido Largo' acc='Tacones' colors={[
        { color: '#511b17' },
        { color: '#c6340c' },
        { color: '#954406' },
        { color: '#c08621' },
        { color: '#7b5738' }
      ]} />

      <Vestimenta name='straj' gen='Hombres' desc='Traje' acc='' type={0} colors={[
        { color: '#272222' },
        { color: '#384a79' },
        { color: '#5471b2' },
        { color: '#7e7e7e' }
      ]} />

       <Hotel
        title='Hoteles Sugeridos'
        name=''
        fecha=''
        hora=''
        dir=''
        icon={Ht}
        center={{ lat:17.98664502133379, lng: -92.94093041123627 }}
        markers={[
          { pos: { lat: 18.000605, lng: -92.937471 }, info: 'La Venta Inn' },
          { pos: { lat: 17.9873365953403, lng: -92.95707895337316 }, info: 'Hotel Carrizal' },
           { pos: { lat: 17.988700247517343, lng: -92.94878903338567 }, info: 'City Express Junior' },
           { pos: { lat: 17.99423061710175, lng: -92.95384914855856 }, info: 'Hampton Inn' },
           { pos: { lat: 17.995502198460226, lng: -92.93997783298752 }, info: 'Hyatt Regency' },
           { pos: { lat: 17.975167734765876, lng: -92.9279100432285 }, info: 'Hotel Mia City' }
        ]} />
  
      {/* <section className="Audio-tag">
        <audio src={song} autoPlay loop controls preload="metadata" type="audio/mpeg">
          Tu navegador no soporta el elemento de audio.
        </audio>
      </section> */}
    </div>

  );
}